export const URL_MARKETPLACE_PERFORM = 'https://marketplace.rio.cloud/product/MAN-SKU00000005';
export const URL_MARKETPLACE_PERFORM_KOREA = 'https://marketplace.rio.cloud/product/KOR-SKU00000054';
export const URL_BUYBUTTON_PERFORM = 'https://buybutton.marketplace.rio.cloud/?productId=MAN-SKU00000005&level=10';
export const URL_BUYBUTTON_PERFORM_KOREA = 'https://buybutton.marketplace.rio.cloud/?productId=MAN-SKU00000054';
export const URL_TOUR_HISTORY = 'https://asset-history.rio.cloud/fleetmonitor/eventHistory#asset-history';
